<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">

        <div class="form container px-2">

        <h5>
            <b>D. TEACHING AND PROFESSIONAL EXPERIENCE:</b>
        </h5>

        <!--Teaching-->
        <div class="mb-4 text-start me-3">
            <div class="mb-3 mt-4">
                <b>
                    D.1 Full-time Post-Masters teaching in a University or at an equivalent level (give
                    dates, employers, post held):
                </b>
            </div>
            <div class="d-flex my-4">
                <span>Number of sessions taught since after Masters degree: </span>&nbsp;&nbsp;
                <span>
                    <input v-model="sessionsTaught" style="width: 70px; padding-left: 10px" type="number">
                </span>
            </div>
            <!--postgraduate teaching-->
            <div class="mb-4">
                <div class="mb-3">
                    <b>(a) Postgraduate Teaching</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#pgTeaching"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=pgTeachings :type="'pgTeachings'" />
            </div>

            <!-- postgraduate teaching modal -->
            <div class="modal fade" id="pgTeaching" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="journalReviewLabel">Postgraduate Teaching</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="pgTeachingText" class="form-label">Describe Course Taught:</label>
                                <span>
                                    <textarea rows="4" v-model="pgTeaching" type="text" class="form-control"
                                        id="pgTeachingText"
                                        placeholder="E.g. Research Methods/Experimental Design. (4 hours contact time per week; PhD; 2017 – current)"></textarea>
                                </span>
                            </div>
                            <div class="mb-3 d-flex">
                                <label for="pgTeachingSessionText" class="form-label">Number of sessions/years:</label>
                                &nbsp;
                                <span>
                                    <input style="width: 100px" v-model="pgTeachingSessions" type="number"
                                        class="form-control" id="pgTeachingSessionText">
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('pgTeaching')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--undergraduate teaching-->
            <div class="mb-4">
                <div class="mb-3">
                    <b>(b) Undergraduate Teaching</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#ugTeaching"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=ugTeachings :type="'ugTeachings'" />
            </div>

            <!-- undergraduate teaching modal -->
            <div class="modal fade" id="ugTeaching" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="journalReviewLabel">Undergraduate Teaching</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="ugTeachingText" class="form-label">Describe Course Taught:</label>
                                <span>
                                    <textarea rows="4" v-model="ugTeaching" type="text" class="form-control"
                                        id="ugTeachingText"
                                        placeholder="E.g. Strength of Materials 1 (4 hours contact time per week; 2nd year; 2014 – 2017)"></textarea>
                                </span>
                            </div>
                            <div class="mb-3 d-flex">
                                <label for="ugTeachingSessionText" class="form-label">Number of sessions/years:</label>
                                &nbsp;
                                <span>
                                    <input style="width: 100px" v-model="ugTeachingSessions" type="number"
                                        class="form-control" id="ugTeachingSessionText">
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('ugTeaching')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Professional Experience-->
            <div class="mb-3 d-flex align-items-center">
                <b>
                    D.2 Relevant professional experience in Industry or appropriate
                    non-teaching/research
                    institution (give dates, employer, and post held):
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#professionalExperience"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>

            <!--Professional Experience Section-->
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=professionalExperiences :type="'professionalExperiences'" />

            <!-- Professional Experience modal -->
            <div class="modal fade" id="professionalExperience" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="journalReviewLabel">Professional
                                Experience</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="professionalExperienceText" class="form-label">Describe Professional
                                    Experience:</label>
                                <span>
                                    <textarea rows="4" v-model="professionalExperience" type="text" class="form-control"
                                        id="professionalExperienceText"></textarea>
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('professionalExperience')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--D3-->
            <div class="mb-3" style="text-align: justify;"> 
                <b>
                    D.3 Specify any degree programs development work, participation in major seminars,
                    supervision of graduate level and post-graduate work, or other teaching/
                    professional experience you consider relevant, especially since appointment/last
                    change of grading in this university:
                </b>
            </div>
            <!--Degree Programmes Development Work-->
            <div class="mb-4">
                <div>
                    <b>(a) Degree Programmes Work:</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#degreeProgram"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=degreePrograms :type="'degreePrograms'" />
            </div>

            <!-- Degree Programmes Development Work modal -->
            <div class="modal fade" id="degreeProgram" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="degreeProgramLabel">Degree Programmes Work</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="degreeProgramText" class="form-label">Degree Programmes Development
                                    Work Details:</label>
                                <span>
                                    <textarea rows="4" v-model="degreeProgram" type="text" class="form-control"
                                        id="degreeProgramText"></textarea>
                                </span>
                                <br>
                                <div>
                                    <label for="degreeProgramUrl" class="form-label">Google Drive Link:</label>
                                    <input v-model="degreeProgramUrl" type="text" class="form-control" id="degreeProgramUrl">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('degreeProgram')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--seminars-->
            <div class="mb-4">
                <div>
                    <b>(b) Participation in Major Seminars:</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#seminarWorkshop"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=seminarWorkshops :type="'seminarWorkshops'" />
            </div>

            <!-- seminar modal -->
            <div class="modal fade" id="seminarWorkshop" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="seminarWorkshopLabel">Major Seminar</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="seminarWorkshopText" class="form-label">Seminar Details:</label>
                                <span>
                                    <textarea rows="4" v-model="seminarWorkshop" type="text" class="form-control"
                                        id="seminarWorkshopText"></textarea>
                                </span>
                                <br>
                                <div>
                                    <label for="seminarWorkshopUrl" class="form-label">Google Drive Link:</label>
                                    <input v-model="seminarWorkshopUrl" type="text" class="form-control" id="seminarWorkshopUrl">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('seminarWorkshop')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>


            <!--pg supervision-->
            <div class="mb-4">
                <div>
                    <b>(c) Supervision of Postgraduate Theses:</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#pgSupervision"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=pgSupervisions :type="'pgSupervisions'" />
            </div>

            <!-- pg supervision modal -->
            <div class="modal fade" id="pgSupervision" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="journalReviewLabel">Postgraduate Supervision</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="pgSupervisionText" class="form-label">Postgraduate Thesis Details:</label>
                                <span>
                                    <textarea rows="4" v-model="pgSupervision" type="text" class="form-control"
                                        id="pgSupervisionText"></textarea>
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('pgSupervision')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--ug supervision-->
            <div class="mb-4">
                <div>
                    <b>(d) Supervision of Undergraduate Theses:</b>
                    <span @click="resetEdit()" class="ms-3">
                        <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#ugSupervision"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </span>
                </div>
                <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=ugSupervisions :type="'ugSupervisions'" />
            </div>

            <!-- ug supervision modal -->
            <div class="modal fade" id="ugSupervision" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="journalReviewLabel">Undergraduate Supervision</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body text-start ms-3">
                            <div class="mb-3">
                                <label for="ugSupervisionText" class="form-label">Undergraduate Thesis Details:</label>
                                <span>
                                    <textarea rows="4" v-model="ugSupervision" type="text" class="form-control"
                                        id="ugSupervisionText"></textarea>
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="joinDetails('ugSupervision')" type="button" class="btn btn-success"
                                data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse mb-5">
            <button @click="saveSection('next')" type="button" class="btn btn-success">Save & Continue</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionD',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return { candidate: '',
            sessionsTaught: 0,
            pgTeaching: '',
            pgTeachingSessions: 1,
            pgTeachings: [],
            ugTeaching: '',
            ugTeachingSessions: 1,
            ugTeachings: [],
            professionalExperience: '',
            professionalExperiences: [],
            degreeProgram: '',
            degreeProgramUrl: '',
            degreePrograms: [],
            seminarWorkshop: '',
            seminarWorkshopUrl: '',
            seminarWorkshops: [],
            pgSupervision: '',
            pgSupervisions: [],
            ugSupervision: '',
            ugSupervisions: [],
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section D');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.pgTeachings.length; i++) {
                this.pgTeachings[i].editing = false
            }
            for (var i=0; i < this.ugTeachings.length; i++) {
                this.ugTeachings[i].editing = false
            }
            for (var i=0; i < this.professionalExperiences.length; i++) {
                this.professionalExperiences[i].editing = false
            }
            for (var i=0; i < this.degreePrograms.length; i++) {
                this.degreePrograms[i].editing = false
            }
            for (var i=0; i < this.seminarWorkshops.length; i++) {
                this.seminarWorkshops[i].editing = false
            }
            for (var i=0; i < this.pgSupervisions.length; i++) {
                this.pgSupervisions[i].editing = false
            }
            for (var i=0; i < this.ugSupervisions.length; i++) {
                this.ugSupervisions[i].editing = false
            }
        },
        
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                sessionsTaught: this.sessionsTaught,
                pgTeachings: this.pgTeachings,
                ugTeachings: this.ugTeachings,
                professionalExperiences: this.professionalExperiences,
                degreePrograms: this.degreePrograms,
                seminarWorkshops: this.seminarWorkshops,
                pgSupervisions: this.pgSupervisions,
                ugSupervisions: this.ugSupervisions
            }

            const res = await DataService.saveData(dataDetails)

            if (res) {
                if (page == 'previous') {
                    this.$router.push('/sectionc')
                } else if (page == 'next') {
                    this.$router.push('/sectione')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionD');

            if (candidate) { this.candidate = candidate;
                this.sessionsTaught = candidate.academicStaff.sessionsTaught ? candidate.academicStaff.sessionsTaught : 0;
                this.pgTeachings = candidate.academicStaff.pgTeachings ? candidate.academicStaff.pgTeachings : [];
                this.ugTeachings = candidate.academicStaff.ugTeachings ? candidate.academicStaff.ugTeachings : [];
                this.professionalExperiences = candidate.academicStaff.professionalExperiences ? candidate.academicStaff.professionalExperiences : [];
                this.degreePrograms = candidate.academicStaff.degreePrograms ? candidate.academicStaff.degreePrograms : [];
                this.seminarWorkshops = candidate.academicStaff.seminarWorkshops ? candidate.academicStaff.seminarWorkshops : [];
                this.pgSupervisions = candidate.academicStaff.pgSupervisions ? candidate.academicStaff.pgSupervisions : [];
                this.ugSupervisions = candidate.academicStaff.ugSupervisions ? candidate.academicStaff.ugSupervisions : [];
            }
        
            this.$emit('toggleLoader');
        },
        joinDetails(category) {
            if (category == 'pgTeaching' && this.pgTeaching) {
                this.pgTeachings.unshift({ data: this.pgTeaching, sessionNum: this.pgTeachingSessions });
                this.pgTeaching = ''
                this.pgTeachingSessions = 1;
            } else if (category == 'ugTeaching' && this.ugTeaching) {
                this.ugTeachings.unshift({ data: this.ugTeaching, sessionNum: this.ugTeachingSessions });
                this.ugTeaching = '';
                this.ugTeachingSessions = 1;
            } else if (category == 'professionalExperience' && this.professionalExperience) {
                this.professionalExperiences.unshift({ data: this.professionalExperience });
                this.professionalExperience = ''
            } else if (category == 'degreeProgram' && this.degreeProgram) {
                this.degreePrograms.unshift({ data: this.degreeProgram, fileUrl: this.degreeProgramUrl });
                this.degreeProgram = ''
            } else if (category == 'seminarWorkshop' && this.seminarWorkshop) {
                this.seminarWorkshops.unshift({ data: this.seminarWorkshop, fileUrl: this.seminarWorkshopUrl });
                this.seminarWorkshop = ''
            } else if (category == 'pgSupervision' && this.pgSupervision) {
                this.pgSupervisions.unshift({ data: this.pgSupervision });
                this.pgSupervision = ''
            } else if (category == 'ugSupervision' && this.ugSupervision) {
                this.ugSupervisions.unshift({ data: this.ugSupervision });
                this.ugSupervision = ''
            }
            this.key += 1
        },
    }
}
</script>
